import { createFileRoute, Link } from '@tanstack/react-router';
import { UnderConstruction } from '@/components/UnderConstruction';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/dashboard/under-construction')({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      squares: search.squares as boolean | undefined,
    };
  },
  component: UnderConstructionPage,
});

function UnderConstructionPage() {
  const search = Route.useSearch();

  if (search.squares) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen p-8">
        <div className="max-w-md text-center space-y-4">
          <h1 className="text-2xl font-bold">Squares Contest Management</h1>
          <p className="text-muted-foreground">Create and manage Squares contests from here.</p>
          <div className="flex gap-4 justify-center mt-6">
            <Link
              to="/dashboard/squares/$id"
              params={{ id: 'new' }}
              search={{ tenant_id: undefined, tab: undefined }}
            >
              <Button>Create New Squares Contest</Button>
            </Link>
            <Link to="/dashboard" search={{}}>
              <Button variant="outline">Back to Dashboard</Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <UnderConstruction
      title="Under Construction"
      message="This page is currently under construction. We're working hard to bring you something amazing. Please check back soon!"
      showHomeButton={true}
    />
  );
}
